import * as moment from 'moment';

import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { Jury } from './jury.model';
import { Salle } from './salle.model';
import { Animateur } from './animateur.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Commission {
    static jsonMap = {
        id: { key: 'id', optional: true },
        dateDebut: { key: 'dateDebut', converter: new DateTimeConverter() },
        dateFin: { key: 'dateFin', converter: new DateTimeConverter() },
        numero: { key: 'numero', optional: true, default: '' },
        salle: { key: 'idSalle', converter: new (DataIdConverterFactory.build(Salle, 'salles'))() },
        jurys: { key: 'jurys', converter: new (ArrayClassConverterFactory.build(Jury))() },
        animateur: { key: 'idAnimateur', converter: new (DataIdConverterFactory.build(Animateur, 'animateurs'))() },
        terminee: { key: 'terminee' },
        annee: { key: 'annee' }
    };

    id: number;
    dateDebut: moment.Moment;
    dateFin: moment.Moment;
    numero: string;
    salle: Salle;
    jurys: Jury[];
    animateur: Animateur;
    terminee: boolean;
    annee: string;
}
